'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scriptElm = void 0;
var isServer = typeof window === 'undefined';
if (isServer) {
    var SCRIPT_STR = "window.onbeforeunload=function(){var d=document,e=encodeURIComponent;!/localhost$|\\.vg\\.no$|\\.vgnett\\.no$/.test(d.domain)&&navigator.sendBeacon&&navigator.sendBeacon('//click.vgnett.no/vg/svg.gif?u='+e(d.location.href)+'&r='+e(d.referrer))}";
    var script = Buffer.from(SCRIPT_STR, 'utf8');
    scriptElm = _react2.default.createElement('script', {
        dangerouslySetInnerHTML: {
            __html: 'eval(atob(' + JSON.stringify(script.toString('base64')) + '));'
        }
    });
}

exports.default = {
    name: 'logo',
    /* eslint-disable max-len */
    shape: _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'm 409.402,85.604 h -154.4 c 0,0 -18.7,1.065 -18.7,-15.648 V 18.748 c 0,-19.907 18.7,-18.696 18.7,-18.696 h 155.993 c 19.127,0 18.79,18.8 18.79,18.8 v 3.136 h -60.956 v -3.425 c 0,0 -0.722,-8.694 -11.128,-8.694 h -47.23 c -12.843,0 -12.498,10.673 -12.498,10.673 v 43.187 c 0,0 -1.431,12.273 11.655,12.273 h 47.618 c 10.79,0 11.835,-10.618 11.835,-10.618 v -16.12 h -34.68 v -9.936 h 95.353 v 28.153 c 0,0 0,18.123 -20.353,18.123 M 73.41,85.71 0,0 H 75.673 L 113.931,57.87 155.205,0 h 74.802 l -74.31,85.71 H 73.41' }),
        scriptElm
    ),
    /* eslint-enable max-len */
    viewbox: '0 0 429.7854 85.709999',
    label: 'VG Logo'
};
//# sourceMappingURL=logo.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/lib/cjs/svg/logo.js
 ** module id = 713
 ** module chunks = 1
 **/